import { Dispatch, SetStateAction } from 'react';
import { PUBLIC_ORGANISATION } from 'src/api';
import axios from 'src/axios';
import { setOrganisationLogo } from 'src/creators/OpenReporting.creators';
import { OpenReportTypes } from 'src/types';

export const getOrganisationResponse = async (
  organisation: string,
  dispatch: Dispatch<{ type: OpenReportTypes; payload: string }>,
  setNotFound: Dispatch<SetStateAction<boolean>>,
) => {
  try {
    const organisationResp = await axios.get(
      PUBLIC_ORGANISATION(organisation.toLowerCase()),
    );
    organisationResp?.data?.data?.logo &&
      dispatch(setOrganisationLogo(organisationResp?.data?.data?.logo));

    setNotFound(false);
  } catch (error: unknown) {
    throw error as Error;
  }
};
